'use client'

import { LinkIcon } from 'lucide-react'
import { useVerifyResetFlow } from '@/lib/commerce/hooks'
import { TextField } from '../elements/Field'
import { authPrimaryButton, authTitle } from './authStyles'

export default function VerifyReset({ vendor }: { vendor: any }) {
  const f = useVerifyResetFlow(vendor)

  if (f.loading) return <div />

  if (!f.valid) {
    return (
      <div>
        <LinkIcon aria-hidden className="size-10 text-muted-foreground" strokeWidth={1} />
        <h1 className={`mt-6 ${authTitle}`}>Холбоос хүчингүй байна</h1>
        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">Нууц үг сэргээх код хүчингүй болсон эсвэл хугацаа нь дууссан байна. Дахин оролдоно уу.</p>
        <button type="button" onClick={f.goToLogin} className={`mt-10 ${authPrimaryButton}`}>Нэвтрэх</button>
      </div>
    )
  }

  return (
    <div>
      <h1 className={authTitle}>Нууц үг сэргээх</h1>
      <p className="mt-3 text-sm text-muted-foreground">Шинэ нууц үгээ оруулна уу</p>
      <form onSubmit={f.handleResetPassword} className="mt-10 flex flex-col gap-5">
        <TextField label="Шинэ нууц үг" type="password" value={f.password} onChange={e => f.setPassword(e.target.value)} placeholder="Таны шинэ нууц үг" onKeyDown={f.handleKeyDown} description="8-аас дээш тэмдэгтэй байх ёстой" autoComplete="new-password" />
        <TextField label="Шинэ нууц үг давтах" type="password" value={f.passwordRep} onChange={e => f.setPasswordRep(e.target.value)} placeholder="Шинэ нууц үг давтах" onKeyDown={f.handleKeyDown} autoComplete="new-password" />
        <button type="submit" disabled={f.btnLoading} className={`mt-2 ${authPrimaryButton}`}>{f.btnLoading ? 'Шинэчилж байна…' : 'Нууц үг солих'}</button>
      </form>
    </div>
  )
}
